import logo from "@/assets/runebox-logo.png";

export const RuneLogo = ({ className = "h-7 w-7" }) => (
  <img src={logo} alt="" aria-hidden="true" className={`${className} object-contain`} />
);
